import React from 'react';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const Tamplate = () => {
  const handleExportTable = () => {
    const table = document.querySelector('table');
    if (!table) {
      console.error('Table element not found');
      return;
    }
    const wb = XLSX.utils.table_to_book(table);
    XLSX.writeFile(wb, 'table_data.xlsx');
  };

  const handleExportPdf = async () => {
    const component = document.querySelector('.template-container'); // Add a ref or class to the main container
    if (!component) {
      console.error('Component container not found');
      return;
    }

    const canvas = await html2canvas(component);
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save('component.pdf');
  };

  return (
    <div className="template-container"> {/* Added a class for PDF export */}
      <div className='col-11 row m-auto justify-content-between align-items-center' >
        <div className='col-sm-6 d-flex align-items-center gap-2'>
          <div style={{ width: '50px' }}>
            <img src={require('../../assets/fev.png')} style={{ width: '100%' }} alt="" />
          </div>
          <div>
            <p className='p-0 m-0'>Open Access Journal Of</p>
            <p className='fw-bold p-0 m-0'>Surgery</p>
            <p className='p-0 m-0' >ISSN:2476-1346</p>
          </div>
        </div>
        <div className='col-sm-6 d-flex justify-content-sm-end align-items-cente'>
          <div style={{ height: '50px' }}>
            <img src={require('../../assets/x.png')} style={{ height: '100%' }} alt="" />
          </div>
        </div>
      </div>
      <div className='col-11 m-auto d-flex  align-items-center' style={{ background: '#273e8b', color: 'white' }} >
        <div className='col-11 m-auto row justify-content-between ' >
          <div className='col-sm-6 text-start'>
            <p className='fw-bold m-0'>Case Report</p>
            <p style={{ fontSize: '14px' }} className='m-0'> <b>Volume 6 Issue z</b> - October <b>2017</b> </p>
            <p style={{ fontSize: '14px' }} className='m-0'><b>DOI</b> 1019000/odjs 2017 0655683</p>
          </div>
          <div className='col-sm-6 d-flex justify-content-sm-end text-sm-end'>
            <div>
              <p className='fw-bold m-0'>Open Assess J Surg</p>
              <p style={{ fontSize: '14px' }} className='m-0'> Copyright @ All right are reserved by Sushill Ladumore B</p>
            </div>
          </div>
        </div>
      </div>

      <div className='col-11 m-auto mt-3'>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>John</td>
              <td>Doe</td>
              <td>@social</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className='col-11 m-auto mt-3 d-flex gap-2'>
        <button className='btn btn-primary' onClick={handleExportTable}>Export Table</button>
        <button className='btn btn-primary' onClick={handleExportPdf}>Export PDF</button>
      </div>
    </div>
  );
};

export default Tamplate;